import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/show-more/show-more.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ShowMoreButton = forwardRef(
  (_a, ref) => {
    var _b = _a, { text, variant, expanded, className } = _b, rest = __objRest(_b, ["text", "variant", "expanded", "className"]);
    return /* @__PURE__ */ jsxs(
      "button",
      __spreadProps(__spreadValues({
        ref,
        className: clsx(
          "hds-show-more",
          variant === "show-more-show-less" && "hds-show-more--show-less",
          className
        ),
        "data-state": expanded ? "expanded" : void 0,
        type: "button"
      }, rest), {
        children: [
          text,
          /* @__PURE__ */ jsx("span", { className: clsx("hds-show-more__icon") })
        ]
      })
    );
  }
);
ShowMoreButton.displayName = "ShowMoreButton";

export {
  ShowMoreButton
};
//# sourceMappingURL=chunk-JUHJZLH2.mjs.map